import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={820}
    height={props.width? `calc( ${props.width}/ 820 * 473 )`: 473}
    viewBox="0 0 820 473"
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="m575 99.5-49.75 86.17h-99.5L376 99.5l49.75-86.17h99.5L575 99.5Z"
      opacity={0.3}
    />
    <path
      fill="#fff"
      d="m706 205-40 69.282h-80L546 205l40-69.282h80L706 205Z"
      opacity={0.2}
    />
    <path
      fill="#fff"
      d="m820 135-30 51.962h-60L700 135l30-51.962h60L820 135Z"
      opacity={0.1}
    />
    <path
      stroke="#fff"
      d="M779.711 239.859 799.423 274l-19.712 34.141h-39.422L720.577 274l19.712-34.141h39.422Z"
      opacity={0.5}
    />
    <g filter="url(ax)">
      <path
        stroke="#fff"
        d="M372.212 36.611 489.422 238.5l-117.21 201.888H137.788L20.578 238.5l117.21-201.889h234.424Z"
        shapeRendering="crispEdges"
      />
    </g>
    <path
      fill="#F1F1F1"
      d="M431.413 239.802 343.206 392.58H166.793L78.587 239.802l88.206-152.778h176.413l88.207 152.778Z"
    />
    <path
      fill="#E7E7E7"
      d="m326.607 361.533 70.955-122.382H113.74l70.955 122.382h141.912Z"
    />
    <path
      fill="#EAEAEA"
      d="M184.695 116.769 113.74 239.151h283.822l-70.955-122.382H184.695Z"
    />
    <g filter="url(#bx)">
      <path
        stroke="#9AFFF9"
        strokeWidth={2}
        d="m342.629 88.024 87.629 151.778-87.629 151.778H167.371l-87.63-151.778 87.63-151.778h175.258Z"
        shapeRendering="crispEdges"
      />
    </g>
    <g filter="url(#cx)">
      <path
        stroke="#9AFFF9"
        strokeWidth={2}
        d="m342.629 88.024 87.629 151.778-87.629 151.778H167.371l-87.63-151.778 87.63-151.778h175.258Z"
        shapeRendering="crispEdges"
      />
    </g>
    <g filter="url(#dx)">
      <path
        stroke="#9AFFF9"
        strokeWidth={2}
        d="m342.629 88.024 87.629 151.778-87.629 151.778H167.371l-87.63-151.778 87.63-151.778h175.258Z"
        shapeRendering="crispEdges"
      />
    </g>
    {/* <path
      fill="#fff"
      d="M224.184 73v-6.48l-5.352-11.28h3.768l1.776 4.344c.528 1.32 1.008 2.568 1.536 3.936h.096c.552-1.368 1.08-2.616 1.608-3.936l1.752-4.344h3.696l-5.352 11.28V73h-3.528Zm14.966.336c-3.768 0-6.696-2.592-6.696-7.032 0-4.368 3.072-7.056 6.24-7.056 3.72 0 5.616 2.688 5.616 6.408 0 .672-.072 1.296-.144 1.632h-8.304c.312 2.208 1.752 3.336 3.744 3.336 1.08 0 2.04-.336 3.024-.936l1.176 2.184c-1.32.912-3 1.464-4.656 1.464Zm-3.336-8.4h5.496c0-1.824-.816-2.976-2.544-2.976-1.416 0-2.664 1.008-2.952 2.976Zm14.245 8.4c-2.4 0-3.96-1.68-3.96-3.984 0-2.856 2.328-4.368 7.728-4.968-.072-1.32-.624-2.304-2.28-2.304-1.248 0-2.472.528-3.696 1.272L246.579 61c1.584-.96 3.48-1.752 5.616-1.752 3.408 0 5.16 2.016 5.16 5.928V73h-2.88l-.264-1.416h-.096c-1.176 1.008-2.52 1.752-4.056 1.752Zm1.152-2.76c1.008 0 1.752-.456 2.616-1.296v-2.712c-3.288.408-4.368 1.296-4.368 2.52 0 1.032.72 1.488 1.752 1.488Zm9.74 2.424V59.584h2.856l.288 2.376h.072c.96-1.776 2.424-2.712 3.816-2.712.72 0 1.152.096 1.56.288l-.6 3.024c-.48-.12-.84-.216-1.416-.216-1.032 0-2.304.72-3.048 2.664V73h-3.528Zm15.962 0v-2.856h3.84V59.392h-3.24v-2.184c1.8-.36 3-.816 4.152-1.512h2.616v14.448h3.336V73h-10.704Z"
    />
    <path
      fill="#000"
      d="M218.117 329.323v-5.184h5.688v-15.228h-4.932v-3.96c2.88-.54 4.752-1.26 6.624-2.448h4.716v21.636h4.824v5.184h-16.92Zm31.189 0v-15.48c0-1.692.144-4.248.216-5.976h-.144a107.295 107.295 0 0 1-2.16 4.608l-3.06 5.292h14.076v4.86h-20.196v-4.428l9.324-15.696h7.92v26.82h-5.976Zm17.654-10.26c-3.924 0-6.768-3.204-6.768-8.568 0-5.364 2.844-8.46 6.768-8.46s6.804 3.096 6.804 8.46c0 5.364-2.88 8.568-6.804 8.568Zm0-3.528c1.26 0 2.34-1.296 2.34-5.04 0-3.744-1.08-4.932-2.34-4.932-1.26 0-2.34 1.188-2.34 4.932 0 3.744 1.08 5.04 2.34 5.04Zm.936 14.292 14.436-27.792h3.672l-14.436 27.792h-3.672Zm19.008 0c-3.888 0-6.768-3.204-6.768-8.568 0-5.364 2.88-8.496 6.768-8.496s6.768 3.132 6.768 8.496c0 5.364-2.88 8.568-6.768 8.568Zm0-3.564c1.26 0 2.34-1.26 2.34-5.004 0-3.78-1.08-4.932-2.34-4.932-1.26 0-2.34 1.152-2.34 4.932 0 3.744 1.08 5.004 2.34 5.004ZM176.635 280.378v-14.66h4.58c2.98 0 5.12 1.08 5.12 4.12 0 2.94-2.14 4.34-5.12 4.34h-2.72v6.2h-1.86Zm1.86-7.7h2.46c2.28 0 3.54-.94 3.54-2.84 0-1.92-1.26-2.6-3.54-2.6h-2.46v5.44Zm6.2 7.7-3.84-6.7 1.44-.96 4.48 7.66h-2.08Zm8.582.28c-2.9 0-5.2-2.12-5.2-5.68 0-3.54 2.38-5.72 4.88-5.72 2.76 0 4.32 1.98 4.32 5.1 0 .38-.02.76-.08 1.04h-7.32c.14 2.3 1.54 3.8 3.62 3.8 1.04 0 1.9-.34 2.7-.88l.66 1.22c-.96.62-2.1 1.12-3.58 1.12Zm-3.42-6.58h5.82c0-2.18-.98-3.36-2.7-3.36-1.52 0-2.88 1.22-3.12 3.36Zm13.241 6.58c-2.32 0-3.08-1.46-3.08-3.62v-6.04h-1.62v-1.36l1.7-.12.2-3.06h1.54v3.06h2.94v1.48h-2.94v6.08c0 1.32.42 2.1 1.68 2.1.38 0 .88-.16 1.22-.3l.36 1.36c-.6.22-1.32.42-2 .42Zm7.299 0c-2.28 0-3.32-1.48-3.32-4.26v-6.88h1.82v6.66c0 2.02.62 2.88 2.06 2.88 1.1 0 1.9-.54 2.92-1.82v-7.72h1.82v10.86h-1.5l-.16-1.7h-.04c-1.02 1.18-2.1 1.98-3.6 1.98Zm8.988-.28v-10.86h1.48l.18 1.98h.06c.74-1.38 1.86-2.24 3.08-2.24.48 0 .8.06 1.16.22l-.34 1.6c-.38-.12-.62-.18-1.06-.18-.9 0-2.02.66-2.74 2.52v6.96h-1.82Zm7.754 0v-10.86h1.48l.18 1.58h.06c1.02-1.02 2.14-1.84 3.64-1.84 2.28 0 3.32 1.48 3.32 4.24v6.88h-1.84v-6.64c0-2.04-.62-2.9-2.06-2.9-1.1 0-1.88.58-2.96 1.66v7.88h-1.82Zm20.9.28c-2.68 0-5.04-2.1-5.04-5.68 0-3.64 2.36-5.72 5.04-5.72 2.66 0 5.02 2.08 5.02 5.72 0 3.58-2.36 5.68-5.02 5.68Zm0-1.52c1.88 0 3.14-1.68 3.14-4.16 0-2.52-1.26-4.2-3.14-4.2-1.9 0-3.16 1.68-3.16 4.2 0 2.48 1.26 4.16 3.16 4.16Zm7.909 1.24v-10.86h1.48l.18 1.58h.06c1.02-1.02 2.14-1.84 3.64-1.84 2.28 0 3.32 1.48 3.32 4.24v6.88h-1.84v-6.64c0-2.04-.62-2.9-2.06-2.9-1.1 0-1.88.58-2.96 1.66v7.88h-1.82Zm22.38.28c-3.66 0-6.38-2.84-6.38-7.6 0-4.72 2.78-7.6 6.5-7.6 1.78 0 3.16.86 4.02 1.8l-1.02 1.2c-.76-.82-1.74-1.38-2.98-1.38-2.78 0-4.62 2.28-4.62 5.94 0 3.7 1.76 6 4.56 6 1.38 0 2.46-.6 3.4-1.64l1 1.16c-1.16 1.36-2.58 2.12-4.48 2.12Zm9.554 0c-1.82 0-3.18-1.14-3.18-3.1 0-2.36 2.04-3.54 6.66-4.06 0-1.4-.44-2.74-2.22-2.74-1.28 0-2.42.6-3.26 1.18l-.72-1.28c1-.64 2.52-1.4 4.26-1.4 2.66 0 3.78 1.76 3.78 4.46v6.66h-1.5l-.16-1.28h-.08c-1.02.86-2.24 1.56-3.58 1.56Zm.5-1.48c1.06 0 1.94-.5 2.98-1.44v-3.02c-3.66.42-4.88 1.32-4.88 2.72 0 1.24.84 1.74 1.9 1.74Zm8.269 5.78v-15.44h1.48l.18 1.26h.06c.98-.82 2.18-1.52 3.44-1.52 2.82 0 4.32 2.18 4.32 5.54 0 3.7-2.22 5.86-4.72 5.86-.98 0-2-.46-2.98-1.26l.04 1.9v3.66h-1.82Zm4.48-5.84c1.78 0 3.12-1.62 3.12-4.3 0-2.42-.82-4.04-2.88-4.04-.92 0-1.84.52-2.9 1.5v5.72c.98.82 1.94 1.12 2.66 1.12Zm7.922 1.26v-10.86h1.82v10.86h-1.82Zm.92-13.1c-.72 0-1.22-.46-1.22-1.22 0-.7.5-1.16 1.22-1.16.7 0 1.22.46 1.22 1.16 0 .76-.52 1.22-1.22 1.22Zm7.988 13.38c-2.32 0-3.08-1.46-3.08-3.62v-6.04h-1.62v-1.36l1.7-.12.2-3.06h1.54v3.06h2.94v1.48h-2.94v6.08c0 1.32.42 2.1 1.68 2.1.38 0 .88-.16 1.22-.3l.36 1.36c-.6.22-1.32.42-2 .42Zm6.092 0c-1.82 0-3.18-1.14-3.18-3.1 0-2.36 2.04-3.54 6.66-4.06 0-1.4-.44-2.74-2.22-2.74-1.28 0-2.42.6-3.26 1.18l-.72-1.28c1-.64 2.52-1.4 4.26-1.4 2.66 0 3.78 1.76 3.78 4.46v6.66h-1.5l-.16-1.28h-.08c-1.02.86-2.24 1.56-3.58 1.56Zm.5-1.48c1.06 0 1.94-.5 2.98-1.44v-3.02c-3.66.42-4.88 1.32-4.88 2.72 0 1.24.84 1.74 1.9 1.74Zm10.19 1.48c-1.38 0-1.92-.88-1.92-2.44v-13.74h1.82v13.86c0 .58.24.8.52.8.08 0 .16 0 .38-.04l.24 1.4c-.26.08-.54.16-1.04.16ZM207.148 209.544v-5.184h5.688v-15.228h-4.932v-3.96c2.88-.54 4.752-1.26 6.624-2.448h4.716v21.636h4.824v5.184h-16.92Zm29.389.504c-4.284 0-7.236-1.62-9.36-3.708l2.916-4.032c1.512 1.44 3.384 2.556 5.508 2.556 2.592 0 4.212-1.404 4.212-4.176 0-2.7-1.62-4.14-3.924-4.14-1.476 0-2.196.288-3.78 1.296l-2.808-1.836.684-13.284h15.048v5.364h-9.54l-.396 4.536c.972-.396 1.764-.54 2.772-.54 4.536 0 8.352 2.664 8.352 8.46 0 6.012-4.536 9.504-9.684 9.504Zm21.722 0c-4.248 0-7.236-1.476-9.18-3.744l2.952-4.032c1.62 1.512 3.492 2.592 5.58 2.592 2.484 0 4.104-1.044 4.104-3.06 0-2.304-1.224-3.672-6.84-3.672v-4.536c4.572 0 6.012-1.368 6.012-3.492 0-1.836-1.08-2.844-3.06-2.844-1.8 0-3.168.792-4.788 2.232l-3.24-3.924c2.484-2.088 5.148-3.312 8.316-3.312 5.544 0 9.18 2.592 9.18 7.38 0 2.664-1.44 4.752-4.284 5.904v.18c2.952.9 5.148 3.06 5.148 6.516 0 5.004-4.572 7.812-9.9 7.812Zm19.669-10.764c-3.924 0-6.768-3.204-6.768-8.568 0-5.364 2.844-8.46 6.768-8.46s6.804 3.096 6.804 8.46c0 5.364-2.88 8.568-6.804 8.568Zm0-3.528c1.26 0 2.34-1.296 2.34-5.04 0-3.744-1.08-4.932-2.34-4.932-1.26 0-2.34 1.188-2.34 4.932 0 3.744 1.08 5.04 2.34 5.04Zm.936 14.292 14.436-27.792h3.672l-14.436 27.792h-3.672Zm19.008 0c-3.888 0-6.768-3.204-6.768-8.568 0-5.364 2.88-8.496 6.768-8.496s6.768 3.132 6.768 8.496c0 5.364-2.88 8.568-6.768 8.568Zm0-3.564c1.26 0 2.34-1.26 2.34-5.004 0-3.78-1.08-4.932-2.34-4.932-1.26 0-2.34 1.152-2.34 4.932 0 3.744 1.08 5.004 2.34 5.004ZM193.147 160.88c-2.06 0-3.84-.84-5.12-2.18l1.1-1.28c1.06 1.12 2.54 1.82 4.06 1.82 1.92 0 3.06-.96 3.06-2.38 0-1.52-1.06-2-2.44-2.6l-2.1-.92c-1.38-.58-2.98-1.62-2.98-3.76 0-2.26 1.94-3.9 4.62-3.9 1.74 0 3.28.74 4.3 1.82l-.98 1.18c-.9-.84-1.98-1.38-3.32-1.38-1.66 0-2.74.84-2.74 2.14 0 1.44 1.28 1.96 2.42 2.44l2.08.9c1.72.74 3.02 1.76 3.02 3.94 0 2.32-1.9 4.16-4.98 4.16Zm11.914 0c-2.68 0-5.04-2.1-5.04-5.68 0-3.64 2.36-5.72 5.04-5.72 2.66 0 5.02 2.08 5.02 5.72 0 3.58-2.36 5.68-5.02 5.68Zm0-1.52c1.88 0 3.14-1.68 3.14-4.16 0-2.52-1.26-4.2-3.14-4.2-1.9 0-3.16 1.68-3.16 4.2 0 2.48 1.26 4.16 3.16 4.16Zm9.829 1.52c-1.38 0-1.92-.88-1.92-2.44V144.7h1.82v13.86c0 .58.24.8.52.8.08 0 .16 0 .38-.04l.24 1.4c-.26.08-.54.16-1.04.16Zm6.103-.28-3.92-10.86h1.88l2.06 6.2c.32 1.06.66 2.16 1 3.18h.08c.34-1.02.68-2.12 1-3.18l2.08-6.2h1.78l-3.84 10.86h-2.12Zm12.333.28c-2.9 0-5.2-2.12-5.2-5.68 0-3.54 2.38-5.72 4.88-5.72 2.76 0 4.32 1.98 4.32 5.1 0 .38-.02.76-.08 1.04h-7.32c.14 2.3 1.54 3.8 3.62 3.8 1.04 0 1.9-.34 2.7-.88l.66 1.22c-.96.62-2.1 1.12-3.58 1.12Zm-3.42-6.58h5.82c0-2.18-.98-3.36-2.7-3.36-1.52 0-2.88 1.22-3.12 3.36Zm10.114 6.3v-10.86h1.48l.18 1.58h.06c1.02-1.02 2.14-1.84 3.64-1.84 2.28 0 3.32 1.48 3.32 4.24v6.88h-1.84v-6.64c0-2.04-.62-2.9-2.06-2.9-1.1 0-1.88.58-2.96 1.66v7.88h-1.82Zm16.467.28c-2.88 0-5.08-2.1-5.08-5.68 0-3.64 2.44-5.72 5.22-5.72 1.42 0 2.42.58 3.18 1.28l-.92 1.2c-.64-.58-1.32-.96-2.16-.96-2 0-3.44 1.68-3.44 4.2 0 2.48 1.38 4.16 3.38 4.16.98 0 1.88-.48 2.56-1.08l.78 1.22c-.96.86-2.22 1.38-3.52 1.38Zm6.174 4.42c-.5 0-.92-.08-1.26-.22l.36-1.46c.2.08.52.16.82.16 1.22 0 2-1 2.46-2.34l.24-.82-4.36-10.88h1.88l2.22 6.04c.34.96.7 2.06 1.06 3.06h.1c.3-1 .62-2.08.9-3.06l1.96-6.04h1.78l-4.1 11.78c-.76 2.14-1.88 3.78-4.06 3.78Zm14.902-4.7v-14.66h4.58c2.98 0 5.12 1.08 5.12 4.12 0 2.94-2.14 4.34-5.12 4.34h-2.72v6.2h-1.86Zm1.86-7.7h2.46c2.28 0 3.54-.94 3.54-2.84 0-1.92-1.26-2.6-3.54-2.6h-2.46v5.44Zm6.2 7.7-3.84-6.7 1.44-.96 4.48 7.66h-2.08Zm6.839.28c-1.82 0-3.18-1.14-3.18-3.1 0-2.36 2.04-3.54 6.66-4.06 0-1.4-.44-2.74-2.22-2.74-1.28 0-2.42.6-3.26 1.18l-.72-1.28c1-.64 2.52-1.4 4.26-1.4 2.66 0 3.78 1.76 3.78 4.46v6.66h-1.5l-.16-1.28h-.08c-1.02.86-2.24 1.56-3.58 1.56Zm.5-1.48c1.06 0 1.94-.5 2.98-1.44v-3.02c-3.66.42-4.88 1.32-4.88 2.72 0 1.24.84 1.74 1.9 1.74Zm11.318 1.48c-2.32 0-3.08-1.46-3.08-3.62v-6.04h-1.62v-1.36l1.7-.12.2-3.06h1.54v3.06h2.94v1.48h-2.94v6.08c0 1.32.42 2.1 1.68 2.1.38 0 .88-.16 1.22-.3l.36 1.36c-.6.22-1.32.42-2 .42Zm4.139-.28v-10.86h1.82v10.86h-1.82Zm.92-13.1c-.72 0-1.22-.46-1.22-1.22 0-.7.5-1.16 1.22-1.16.7 0 1.22.46 1.22 1.16 0 .76-.52 1.22-1.22 1.22Zm8.808 13.38c-2.68 0-5.04-2.1-5.04-5.68 0-3.64 2.36-5.72 5.04-5.72 2.66 0 5.02 2.08 5.02 5.72 0 3.58-2.36 5.68-5.02 5.68Zm0-1.52c1.88 0 3.14-1.68 3.14-4.16 0-2.52-1.26-4.2-3.14-4.2-1.9 0-3.16 1.68-3.16 4.2 0 2.48 1.26 4.16 3.16 4.16Z"
    /> */}
    <defs>
      <filter
        id="ax"
        width={510}
        height={444.777}
        x={0}
        y={16.111}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={10} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.603922 0 0 0 0 1 0 0 0 0 0.976471 0 0 0 1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_208_4" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_208_4"
          result="shape"
        />
      </filter>
      <filter
        id="bx"
        width={432.826}
        height={385.556}
        x={38.587}
        y={47.024}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={20} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.00138855 0 0 0 0 0.880167 0 0 0 0 1 0 0 0 1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_208_4" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_208_4"
          result="shape"
        />
      </filter>
      <filter
        id="cx"
        width={432.826}
        height={385.556}
        x={38.587}
        y={47.024}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={20} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.00138855 0 0 0 0 0.880167 0 0 0 0 1 0 0 0 1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_208_4" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_208_4"
          result="shape"
        />
      </filter>
      <filter
        id="dx"
        width={432.826}
        height={385.556}
        x={38.587}
        y={47.024}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={20} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.00138855 0 0 0 0 0.880167 0 0 0 0 1 0 0 0 1 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_208_4" />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_208_4"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default SvgComponent
